"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyMarineAerospace() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="why-marine-aerospace" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col gap-6 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-accent tracking-tight">
              Why Do Marine and Aerospace OEMs Use Evermark?
            </h2>
            
            <div className="space-y-6 text-foreground text-lg leading-relaxed">
              <p>
                Marine and aerospace marking is specification-driven and audited. An equipment nameplate or a marked part has to meet the marking standard called out in the contract — the right material, the right content, the right durability — and it has to be traceable. A marking that does not meet the spec can hold up an acceptance or fail a supplier audit.
              </p>
              <p>
                Evermark Industrial Solutions produces marine and aerospace marking that is built to the standard the program specifies. MIL-SPEC phenolic and metal nameplates for equipment and data plates, and direct part marking with serialization and 2D data matrix for traceability — produced from the customer's specification and drawing, with a first article approved before a run.
              </p>
              <p>
                Evermark works as a marking supplier, not the design or quality authority. The OEM specifies the standard, the content, and the verification level; Evermark produces the marking to that specification and supplies the documentation the program requires.
              </p>
            </div>
          </div>

          {}
          <div ref={imgRef} className={`relative transition-all duration-1000 delay-200 ease-out ${isImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-lg overflow-hidden border border-border shadow-xl">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/marine_aerospace_workflow_context.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/marine_aerospace_workflow_context.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/marine_aerospace_workflow_context.png-wvc-sizes" alt="Marine and aerospace marking workflow and context" className="object-cover w-full h-full" loading="lazy" decoding="async" />
                {}
                <div className="absolute inset-0 bg-secondary/10 mix-blend-multiply pointer-events-none" />
              </AspectRatio>
            </div>
            
            {}
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-primary/10 rounded-lg blur-3xl pointer-events-none" />
            <div className="absolute -top-8 -right-8 w-40 h-40 bg-secondary/20 rounded-lg blur-3xl pointer-events-none" />
          </div>

        </div>
      </div>
    </section>;
}